const user = {
    keyId: ['user'] as const,
    getMe: () => [...user.keyId, 'getMe'] as const,
    getMyPermission: () => [...user.keyId, 'getMyPermission'] as const,
    getUsers: (query?: string) => [...user.keyId, 'getUsers', query] as const,
    getUserDetail: (userID?: number) => [...user.keyId, 'getUserDetail', userID] as const,
    getUserRecentState: (userID?: number) => [...user.keyId, 'getUserRecentState', userID] as const,
    getUserStatAverage: (userID?: number) => [...user.keyId, 'getUserStatAverage', userID] as const,
    getUserCharts: (userID?: number) => [...user.keyId, 'getUserCharts', userID] as const,
    getUserCharts10Minutes: (userID?: number) =>
        [...user.keyId, 'getUserCharts10Minutes', userID] as const,
    getUserDailyPosition: (userID?: number, date?: string) =>
        [...user.keyId, 'getUserDailyPosition', userID, date] as const,
    getUserMonthAvailability: (userID?: number, year?: number, month?: number) =>
        [...user.keyId, 'getUserMonthAvailability', userID, year, month] as const,
    getUsersSimple: () => [...user.keyId, 'getUsersSimple'] as const,
    getUsersBbox: () => [...user.keyId, 'getUsersBbox'] as const,
    getUsersDeviceStatus: () => [...user.keyId, 'getUsersDeviceStatus'] as const
}

const notification = {
    keyId: ['notification'] as const,
    getEmergencyAlertLive: () => [...notification.keyId, 'getEmergencyAlertLive'] as const,
    getEmergencyAlertToday: () => [...notification.keyId, 'getEmergencyAlertToday'] as const,
    getAlertBioToday: () => [...notification.keyId, 'getAlertBioToday'] as const,
    getAlertBioLive: () => [...notification.keyId, 'getAlertBioLive'] as const,
    apiGetAlertFallDetectionLive: () =>
        [...notification.keyId, 'apiGetAlertFallDetectionLive'] as const,
    getAlertBioDetail: (id?: number) => [...notification.keyId, 'getAlertBioDetail', id] as const,
    getAlertEmergencyDetail: (id?: number) =>
        [...notification.keyId, 'getAlertEmergencyDetail', id] as const,
    apiGetNotificationSos: (query?: string) =>
        [...notification.keyId, 'apiGetNotificationSos', query] as const,
    apiGetNotificationFallDetection: (query?: string, props?: any) =>
        [...notification.keyId, 'apiGetNotificationFallDetection', query, props] as const,
    apiGetNotificationBio: (query?: string) =>
        [...notification.keyId, 'apiGetNotificationBio', query] as const,
    getUrgentNotification: () => [...notification.keyId, 'getUrgentNotification'] as const,
    getUrgentNotificationHistory: () =>
        [...notification.keyId, 'getUrgentNotificationHistory'] as const,
    getFallDetectionDetail: (id?: number) => ['notification', 'getFallDetectionDetail', id]
}

const mentalHealth = {
    keyId: ['mentalHealth'] as const,
    getDashboard: () => [...mentalHealth.keyId, 'dashboard'] as const,
    getReports: (params?: any) => [...mentalHealth.keyId, 'reports', params] as const,
    getReportDetail: (id?: number) => [...mentalHealth.keyId, 'reports', 'detail', id] as const,
    uploadBCG: () => [...mentalHealth.keyId, 'uploadBCG'] as const,
    getSessions: (protecteeId: number, params?: any) => [...mentalHealth.keyId, 'sessions', protecteeId, params] as const,
    getSession: (protecteeId: number, sessionId: string) => [...mentalHealth.keyId, 'session', protecteeId, sessionId] as const,
    getSessionBCGData: (protecteeId: number, sessionId: string) => [...mentalHealth.keyId, 'sessionBCGData', protecteeId, sessionId] as const
}

export const QueryCacheKeys = {
    user,
    notification,
    mentalHealth
}
